import { connect } from 'react-redux';
import DrawingCanvas, {
  DrawingCanvasArrangementProps,
} from '../../drawing/components/DrawingCanvas';
import { AppStates } from '../../reducers/app';
import { SheetLayout } from '../../utils/view';
import { ViewTransformSelectorProps, viewTransformSelector } from '../../selectors/zoomingSelector';
import { fundamentalSizeMultiplier } from '../../drawing/constants';

const mapTransformDataToProps =
  (state: AppStates, props: ViewTransformSelectorProps): DrawingCanvasArrangementProps => {
    const { transform, arrangementInfo } = viewTransformSelector(state, props);
    if (arrangementInfo.layout !== SheetLayout.Fixed) {
      throw new Error('DrawingCanvas can be used only for FXL sheet.');
    }

    const { scale, translateX, translateY } = transform;
    return {
      translateX,
      translateY,
      scale: scale / fundamentalSizeMultiplier,
      pageAreaWidth: arrangementInfo.containerWidth,
      pageAreaHeight: arrangementInfo.containerHeight,
      fundamentalWidth: arrangementInfo.sheetWidth * fundamentalSizeMultiplier,
      fundamentalHeight: arrangementInfo.sheetHeight * fundamentalSizeMultiplier,
    };
  };

export default connect(mapTransformDataToProps)(DrawingCanvas);
